"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFuture = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function IconFuture() {
    return ((0, jsx_runtime_1.jsx)("svg", { "data-testid": "progress-icon-future", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("rect", { x: "1", y: "1", width: "22", height: "22", rx: "12", stroke: "#636363" }) }));
}
exports.IconFuture = IconFuture;
